<template>
  <div>
    <van-nav-bar
      title="活动介绍"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/recharge')"
    />
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "Activities",
  data() {
    return {
      content: "",
      type: 0,
    };
  },
  methods: {
    getActivities() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "active_activity",
            activityid: that.type,
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.content = resData.data;
          } else {
            that.$toast.fail(resData.msg);
          }
        });
    },
  },
  mounted: function () {
    let that = this;
    that.type = this.$route.params.type;
    this.getActivities();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Activities.vue